import Cookies from 'js-cookie';
const cookies = Cookies;

const userLoggedCookieName = 'user-logged';

export function cleanupToken() {
  cookies.remove(userLoggedCookieName);

  delete localStorage.authInfo;
}

export function getAuthenticationInfo() {
  if (typeof (localStorage) === 'object' && localStorage.authInfo) {
    try {
      return JSON.parse(localStorage.authInfo);
    }
    catch (e) {
      console.error('unable to parse token');
      cleanupToken();
    }
  }
}

export function checkToken() {
  if (localStorage.authInfo) {
    try {
      JSON.parse(localStorage.authInfo);

      const expired = new Date() > new Date(JSON.parse(localStorage.authInfo).ExpireAt);

      if (expired) {
        throw new Error('expired');
      }
      return true;
    }
    catch (e) {
      console.error(`something went wrong while parsing the token: ${e}`);
    }
  }

  cleanupToken();

  return false;
}

export function storeToken(authInfo) {
  const expiration = new Date(authInfo.ExpireAt);
  cookies.set(userLoggedCookieName, 'true', { expires: expiration, path: '/' });
  localStorage.authInfo = JSON.stringify(authInfo);
}